import { render, staticRenderFns } from "./TelegramBanner.vue?vue&type=template&id=50e1fc12&scoped=true&"
import script from "./TelegramBanner.vue?vue&type=script&lang=js&"
export * from "./TelegramBanner.vue?vue&type=script&lang=js&"
import style0 from "./TelegramBanner.vue?vue&type=style&index=0&id=50e1fc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e1fc12",
  null
  
)

export default component.exports